import { FC, useState } from 'react'
import { Alert, Input, message } from 'antd'
import { useDispatch } from 'react-redux'
import useRequest, { RequestTypes } from '../../../hooks/useRequest'
import { Modal, CloseModal } from '../../../ui'
import { ButtonsBlock } from '../../../Edit/components'
import { getUser } from '../../../../store/user'

import style from './style.m.less'
import { useTranslation } from 'react-i18next'

interface IChangeRoleModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    currentEmail: string
    userId?: string
}

const ChangeEmailModal: FC<IChangeRoleModal> = ({
    isModalVisible,
    setIsModalVisible,
    currentEmail,
    userId,
}) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [email, setEmail] = useState('')
    const [isCloseModalVisible, setIsCloseModalVisible] = useState(false)

    const { fetch } = useRequest({
        // change - если меняет Админ
        // update - если пользователь меняет сам
        link: `/api/auth/v1/email-${userId ? 'change' : 'update'}`,
        method: RequestTypes.post,
    })

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const confirmCloseModal = () => {
        setEmail('')
        setIsCloseModalVisible(false)
        setTimeout(() => {
            setIsModalVisible(false)
        }, 0)
    }

    const onChange = (e: any) => {
        setEmail(e.target.value)
    }

    const openCloseModal = () => {
        if (email !== '') {
            setIsCloseModalVisible(true)
        } else {
            handleOk()
        }
    }

    const onFinish = async () => {
        if (email) {
            const body = userId
                ? {
                      uid: userId,
                      email_new: email,
                  }
                : {
                      email,
                  }
            fetch({
                body,
                errorCodeMessage: true,
                onSuccess: () => {
                    setEmail('')
                    setIsModalVisible(false)
                    if (!userId) {
                        dispatch(getUser())
                    }
                },
                successMessage: {
                    title: t('edit.success'),
                    description: t('login.successEmailChange'),
                },
            })
        } else {
            message.error(t('errors.register.emailFormat'))
        }
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <div className={style.modalHeader}>{t('myProfile.titleChangeEmail')}</div>
            <div className={style.inputBlock}>
                <div className={style.currentEmail}>{t('myProfile.labelCurrentChangeEmail')}</div>
                <div>{currentEmail}</div>
            </div>
            <div className={style.inputBlock}>
                <div>{t('myProfile.labelNewChangeEmail')}</div>
                <Input type={'email'} value={email} className={style.input} onChange={onChange} />
            </div>
            <Alert
                message={
                    <div className={style.modalAlertText}>
                        <div>{t('myProfile.changeEmailText')}</div>
                        <div>{t('myProfile.changeEmailText2')}</div>
                    </div>
                }
                type="info"
                showIcon
                className={style.alert}
            />
            <div className={style.buttonsBlock}>
                <ButtonsBlock
                    confirmAction={onFinish}
                    cancelAction={openCloseModal}
                    cancelTitle={t('documents.cancel')}
                    confirmTitle={t('profile.change')}
                />
            </div>
            <CloseModal
                isModalVisible={isCloseModalVisible}
                setIsModalVisible={setIsCloseModalVisible}
                headerText={t('edit.titleCancelEmail')}
                messageText={t('edit.messageCancelEmail')}
                confirmTitle={t('edit.buttonYes')}
                cancelTitle={t('edit.buttonNo')}
                confirmAction={confirmCloseModal}
            />
        </Modal>
    )
}

export default ChangeEmailModal
